@let langs = languages();
<nav class="sir-utility-bar" aria-label="Utility navigation">
    <ul class="sir-utility-bar-tabs" aria-label="Hub navigation">
        @for (item of tabViews(); track item.tab.name) {
            <li class="sir-utility-bar-tab" [class.is-active]="item.isActive">
                <a
                    [class]="item.linkClass"
                    [siriusLink]="item.tab.link"
                    [attr.aria-current]="item.isActive ? 'page' : null"
                    (linkSelect)="onClick(item.tab.link, $event)">
                    {{ item.tab.link.title }}
                </a>
            </li>
        }
    </ul>
    <ul class="sir-utility-bar-links" aria-label="Global actions">
        @for (link of globalLinks(); track link.href) {
            <li>
                <a
                    class="sir-text-style-paragraph-s-default"
                    [siriusLink]="link"
                    (linkSelect)="onClick(link, $event)">
                    {{ link.title }}
                </a>
            </li>
        }
        @if (langs) {
            <li>
                <button
                    type="button"
                    class="sir-text-style-paragraph-s-default"
                    aria-haspopup="dialog"
                    [attr.aria-label]="'Select language, current: ' + langs.selected.shortName"
                    [attr.aria-controls]="showLanguageSelector() ? 'utility-language-picker' : null"
                    [attr.aria-expanded]="showLanguageSelector()"
                    (click)="onLanguageSelectorToggle()">
                    <sirius-icon [name]="langs.selected.flag" aria-hidden="true"></sirius-icon>
                    {{ langs.selected.shortName }}
                    <sirius-icon [name]="'caret_down'" aria-hidden="true"></sirius-icon>
                </button>
            </li>
        }
    </ul>
</nav>
@if (langs && showLanguageSelector()) {
    <sirius-language-picker id="utility-language-picker" (closeEvent)="onLanguageSelectorClose()" [languages]="langs">
    </sirius-language-picker>
}
